import { useTranslation } from '../../../contexts/TranslationContext';
import { MHMNumberInput, type MHMNumberInputProps } from './MHMNumberInput';

function Millimetres(props: MHMNumberInputProps) {
  const { slotProps, ...rest } = props;
  const { language } = useTranslation();

  return language === 'en-US' ? null : (
    <MHMNumberInput
      slotProps={{ input: { endAdornment: 'mm' }, ...slotProps }}
      {...rest}
    />
  );
}

function Feet(props: MHMNumberInputProps) {
  const { slotProps, ...rest } = props;
  const { language } = useTranslation();
  return language === 'en-US' ? (
    <MHMNumberInput
      slotProps={{ input: { endAdornment: "'" }, ...slotProps }}
      {...rest}
    />
  ) : null;
}

function Inches(props: MHMNumberInputProps) {
  const { slotProps, ...rest } = props;
  const { language } = useTranslation();
  return language === 'en-US' ? (
    <MHMNumberInput
      slotProps={{ input: { endAdornment: '"' }, ...slotProps }}
      {...rest}
    />
  ) : null;
}

export const MHMDistanceInputs = {
  Millimetres,
  Feet,
  Inches,
};
